module.exports = __webpack_public_path__ + "event.0530d582.png";